
document.documentElement.classList.remove('no-js');

document.addEventListener('DOMContentLoaded', () => {
  // Team search
  document.querySelectorAll('[data-team-search]').forEach(input => {
    const section = input.closest('[data-team-directory]');
    if (!section) return;
    const cards = [...section.querySelectorAll('[data-team-card]')];
    const empty = section.querySelector('[data-team-empty]');
    const filter = () => {
      const q = input.value.trim().toLowerCase();
      let visible = 0;
      cards.forEach(card => {
        const show = !q || (card.dataset.teamName || '').includes(q);
        card.hidden = !show;
        if (show) visible++;
      });
      if (empty) empty.hidden = visible !== 0;
    };
    input.addEventListener('input', filter);
  });

  // Product gallery
  document.querySelectorAll('[data-media-target]').forEach(btn => {
    btn.addEventListener('click', () => {
      const root = btn.closest('[data-product-root]');
      if (!root) return;
      root.querySelectorAll('[data-media-id]').forEach(el => el.classList.toggle('is-active', String(el.dataset.mediaId) === String(btn.dataset.mediaTarget)));
      root.querySelectorAll('[data-media-target]').forEach(el => el.classList.toggle('is-active', el === btn));
    });
  });

  // Quantity
  document.querySelectorAll('[data-qty-minus],[data-qty-plus]').forEach(btn => {
    btn.addEventListener('click', () => {
      const control = btn.closest('.quantity-control');
      const input = control?.querySelector('input');
      if (!input) return;
      const n = Math.max(1, Number(input.value || 1) + (btn.hasAttribute('data-qty-plus') ? 1 : -1));
      input.value = n;
    });
  });

  // Variant selection
  document.querySelectorAll('[data-product-root]').forEach(root => {
    const variantsEl = root.querySelector('[data-product-json]');
    if (!variantsEl) return;
    let variants = [];
    try { variants = JSON.parse(variantsEl.textContent); } catch(e) { return; }
    const radios = [...root.querySelectorAll('.variant-fieldset input[type="radio"]')];
    const idInput = root.querySelector('[data-variant-id]');
    const addBtn = root.querySelector('[data-add-to-cart]');
    const price = root.querySelector('[data-product-price]');
    const formatMoney = cents => new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency', currency: window.Shopify?.currency?.active || 'EUR'}).format(cents/100);
    const update = () => {
      const selected = [];
      root.querySelectorAll('.variant-fieldset').forEach(fs => selected.push(fs.querySelector('input:checked')?.value));
      const variant = variants.find(v => v.options.every((x,i) => x === selected[i]));
      if (!variant) return;
      if (idInput) idInput.value = variant.id;
      if (addBtn) { addBtn.disabled = !variant.available; addBtn.querySelector('[data-add-label]').textContent = variant.available ? 'Add to cart' : 'Sold out'; const p=addBtn.querySelector('[data-add-price]'); if(p) p.textContent='· '+formatMoney(variant.price); }
      if (price) price.innerHTML = (variant.compare_at_price && variant.compare_at_price > variant.price ? '<s>'+formatMoney(variant.compare_at_price)+'</s>' : '') + '<span>'+formatMoney(variant.price)+'</span>';
    };
    radios.forEach(r => r.addEventListener('change', update));
  });
});
